const actions = {
  LIST_GASTOS: 'LIST_GASTOS',
  LIST_GASTOS_SELECTBOX: 'LIST_GASTOS_SELECTBOX',
  CREATE_GASTOS: 'CREATE_GASTOS',
  READ_GASTOS: 'READ_GASTOS',
  UPDATE_GASTOS: 'UPDATE_GASTOS',
  DELETE_GASTOS: 'DELETE_GASTOS',


  gastosList: data => {     
    return {
      type: actions.LIST_GASTOS,
      data,
    };
  },

  gastosListSelectBox: data => {
    return {
      type: actions.LIST_GASTOS_SELECTBOX,
      data,
    };
  },

  gastosCreate: data => {
    return {
      type: actions.CREATE_GASTOS,
      data,
    };
  },

  gastosRead: data => {
    return {
      type: actions.READ_GASTOS,
      data,
    };
  },

  gastosUpdate: data => {
    return {
      type: actions.UPDATE_GASTOS,
      data,
    };
  },

  gastosDelete: () => {
    return {
      type: actions.DELETE_GASTOS,      
    };
  },
};

export default actions;
